module.exports = __webpack_public_path__ + "static/reordify-40ba14deb680ecb0d53b2f6fb41db9c6.svg";